import { List, TextField, EditButton, SimpleList, Datagrid, TopToolbar, CreateButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { FOREIGN_LANGUAGES, MOBILE_BREAKPOINT } from "utils/constants";
import { EducationsExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListForeignLanguages = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={EducationsExporter(FOREIGN_LANGUAGES)} />
      </TopToolbar>
    );
  };

  return (
    <List
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateForeignLanguages)} />}
      title="Списък чужди езици"
      sx={settings.style.expandStyle}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
          )}
          tertiaryText={record => (
            <>{checkPermission(userPermissions, permissions.canUpdateForeignLanguages) && <EditButton label="" />}</>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canUpdateForeignLanguages) && <EditButton />}
        </Datagrid>
      )}
    </List>
  );
};
export default ListForeignLanguages;
